module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step4_Image3a.5909ae91.webp";